import { render, staticRenderFns } from "./krasDetail.vue?vue&type=template&id=60c22b3b"
import script from "./krasDetail.vue?vue&type=script&lang=js"
export * from "./krasDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60c22b3b')) {
      api.createRecord('60c22b3b', component.options)
    } else {
      api.reload('60c22b3b', component.options)
    }
    module.hot.accept("./krasDetail.vue?vue&type=template&id=60c22b3b", function () {
      api.rerender('60c22b3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kras/krasDetail.vue"
export default component.exports